<div class="comments-details">
    <form [formGroup]="commentsForm" *ngIf="editMode" class="comment-form">
        <div class="form-group">
            <p-editor #editor formControlName="description" 
                      [style]="{ width: '100%' }" 
                      [modules]="{ toolbar: false }"
                      (onTextChange)="autoResize($event)">
            </p-editor>
            <action-button class="btn-save" (actionEvent)="saveComment($event)" icon="save">
            </action-button>
        </div>
    </form>
    <div>
        <messages [form]="commentsForm" 
                  [messagesObserver]="messages" 
                  fieldname="description"
                  [showNonFieldKeys]="TRUE" 
                  [showFieldName]="TRUE" 
                  [showFieldKeys]="FALSE">
        </messages>
    </div>
</div>